import React, {Component} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelContainer,
  Icon,
  PanelFooter,
} from '@sketchpixy/rubix';

import {getRoles} from '../../../api/api';
import {Link, withRouter} from 'react-router';
import moment from 'moment';
import {routeUrl} from '../../routeUrl';
import {checkRole} from '../../../util/RoleChecker';
import RoleType from '../../RoleGroup/Roles/RoleType';

@withRouter
export default class Role extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: [],
    };
  }

  componentDidMount() {
    const requiredRoles = [
      RoleType.PERMISSION_GROUP,
      RoleType.PERMISSION_GROUP_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = null;

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    getRoles((err, result) => {
      this.setState({roles: result.roles});
    });
  }

  render() {
    return (
        <PanelContainer controls={false}>
          <Panel>
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3><Icon bundle='stroke-gap-icons' glyph='Puzzle' />&nbsp; User roles</h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Link to={routeUrl.adminRoleCreate}>
                      <div style={{'float': 'right', fontSize: '18px'}}>
                        <Icon bundle='fontello' glyph='plus-squared-alt' />
                        &nbsp;Create new
                      </div>
                    </Link>
                    <Table id="permissionTable" style={{tableLayout: 'fixed'}}>
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Pattern</th>
                        <th>key</th>
                        <th>Created</th>
                        <th style={{width: '5%'}}>&nbsp;</th>
                      </tr>
                      </thead>
                      <tbody>
                      {
                        this.state.roles.map(role => (
                            <tr id={role.roleId} key={role.roleId}>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                                {role.roleName}
                              </td>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                                {role.roleDescription}
                              </td>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                              {role.rolePattern}
                              </td>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                              {role.roleEnumKey}
                              </td>
                              <td>{moment(role.createdTime).format('llll')}</td>
                              <td>
                                <Link to={`${routeUrl.adminRoleEdit}/${role.roleId}`}>
                                  <Icon bundle='fontello' glyph='pencil icon-2x' />
                                  &nbsp;
                                </Link>
                              </td>
                            </tr>
                        ))
                      }
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Grid>
            </PanelBody>
            <PanelFooter>
              <Grid>
                <Row>
                  <Col xs={12} className='fg-white' style={{marginBottom: '20px'}} />
                </Row>
              </Grid>
            </PanelFooter>
          </Panel>
        </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/permission/Role/Roles.js